<div class="card settings-page">
  <app-grid-client-side
    pageTitle="users"
    storageKey="usersAndPermissions"
    [rowData]="users"
    [colDefs]="$any(colDefs())"
    [loading]="loading"
    (select)="selectUsers($event)"
    (gridReady)="onGridReady($event)"
  >
    <div class="grid-controls-middle d-flex justify-content-end gap-12">
      <app-button
        *appHasRole="['Admin']"
        text="Invite User"
        iconClass="icon ic-add-20"
        (clickBtn)="openCreateEditUserModal()"
      />
    </div>
  </app-grid-client-side>
</div>
